<template>
  <select class="form-control" :name="$props.name" v-model="tempValue" v-on:change="$emit('input', tempValue)">
    <option v-for="country in countries" :value="country.name" :key="country.code">{{country.name}}</option>
  </select>
</template>

<script>
import countries from "@/countries.js";

export default {
  name: "CountryInput",
  props: {
    name: String,
    value: String
  },
  data() {
    return {
      tempValue: this.$props.value,
      countries: countries
    };
  }
};
</script>